import { z } from 'zod';
import { emailSchema } from './primitives.js';
export const listCustomersQuerySchema = z.object({
    search: z.string().max(255).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
export const createCustomerSchema = z.object({
    email: emailSchema,
    firstName: z.string().max(255).optional(),
    lastName: z.string().max(255).optional(),
    phone: z.string().max(50).optional(),
    acceptsMarketing: z.boolean().default(false),
    note: z.string().max(5000).optional(),
    tags: z.array(z.string().max(64)).max(50).default([]),
});
//# sourceMappingURL=customer.js.map